import { render, staticRenderFns } from "./JoinCast.vue?vue&type=template&id=345c2a22&scoped=true&"
import script from "./JoinCast.vue?vue&type=script&lang=js&"
export * from "./JoinCast.vue?vue&type=script&lang=js&"
import style0 from "./JoinCast.vue?vue&type=style&index=0&id=345c2a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c2a22",
  null
  
)

export default component.exports